import CommonUtils from "services/common/utils";
import XHTTP from "services/api/xhttp";
import paths from "routes/paths";

class MapApi {
  static END_POINTS = {
    areas: paths.api.layers.infos.areas,
    points: paths.api.layers.infos.points,
    paths: paths.api.layers.infos.paths,
    getMapConfigEndpoint: (id) => paths.api.users.config.map.replace(":id", id),
  };

  static getMapConfig(id) {
    return XHTTP(MapApi.END_POINTS.getMapConfigEndpoint(id), {
      method: "get",
    });
  }

  static getAreasInfos(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(`${MapApi.END_POINTS.areas}?${queryString}`, {
      method: "get",
    });
  }

  static getPointsInfos(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(`${MapApi.END_POINTS.points}?${queryString}`, {
      method: "get",
    });
  }

  static getPathsInfos(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(`${MapApi.END_POINTS.paths}?${queryString}`, {
      method: "get",
    });
  }
}

export default MapApi;
